import React, { useEffect, useState } from "react";
import img from "../../../Assets/SharedStyle/Shoman & Arab Bank - logos - Final-02.png";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import ButtonAHSF from "../../../Components/ButtonAHSF";
import LogOutServices from "../../../Services/Account/LogOutServices";
import loadConfig from "../../../Services/Api/ApiServices";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import "./style.css";
import {
  fabyPrefixAndName,
  faEarthAmericas,
  faGlobe,
} from "@fortawesome/free-solid-svg-icons";
import { setLanguage } from "../../../Redux/Reducers/Shared/language";
import { UpdateAcademicAchievement } from "../../../Redux/Reducers/Submitter/AcademicAchievement";
import { UpdateCurrentJobInformationSpecialization } from "../../../Redux/Reducers/Submitter/CurrentJobInformationSpecialization";
import { UpdateAI_NT_ApI_ApplicantInformation } from "../../../Redux/Reducers/Submitter/ApplicantInformation";
import { UpdateAC_NT_AS_AwardSource } from "../../../Redux/Reducers/Submitter/AwardSource";
import { UpdateAC_NT_CM_Commitment } from "../../../Redux/Reducers/Submitter/Commitment";
import { UpdateQuestionsAnswersList } from "../../../Redux/Reducers/Submitter/QuestionsAnswers";
import { UpdateSC_NT_RI_ResearcherIndicators } from "../../../Redux/Reducers/Submitter/ResearcherIndicators";
import { UpdateSC_NT_AI_ApplicationInformation } from "../../../Redux/Reducers/Submitter/SC_NT_AI_ApplicationInformation";
import { Accessibility } from "accessibility";
import { GetActiveRoundRemaining } from "../../../Redux/Reducers/Shared/ApplicationInformation";
const Header = (props) => {
  const [dataJsonObject, SetDataJsonObject] = useState();
  const UserInfo = useSelector((state) => state.UserInfo.UserInfo);
  const activeRound = useSelector(
    (state) => state.ApplicationInformation.ActiveRound
  );
  console.log(activeRound, "activeRound");

  const { ApplicationInformationId } = useParams();
  // let accessibilityInstance;

  const state = useSelector((state) => {
    return {
      UserInfo: state.UserInfo,
    };
  });
  const dispatch = useDispatch();
  const navigate = useNavigate();
  let location = useLocation();
  const ApplicantInformation = useSelector(
    (state) => state.ApplicantInformation.ApplicantInformation
  );
  const ActiveRoundRemaining = useSelector(
    (state) => state.ApplicationInformation.ActiveRoundRemaining
  );
  console.log(ActiveRoundRemaining, "ActiveRoundRemaining");

  const academicAchievement = useSelector(
    (state) => state.AcademicAchievement.AcademicAchievement
  );
  const currentJobInformationSpecialization = useSelector(
    (state) =>
      state.CurrentJobInformationSpecialization
        .CurrentJobInformationSpecialization
  );
  const AwardSource = useSelector((state) => state.AwardSource.AwardSource);
  const Commitment = useSelector((state) => state.Commitment.Commitment);
  const SC_NT_AI_ApplicationInformation = useSelector(
    (state) =>
      state.SC_NT_AI_ApplicationInformation.SC_NT_AI_ApplicationInformation
  );
  const QuestionsAnswers = useSelector(
    (state) => state.QuestionsAnswers.QuestionsAnswers
  );
  const ResearcherIndicators = useSelector(
    (state) => state.ResearcherIndicators.ResearcherIndicators
  );

  const ActiveRound = useSelector(
    (state) => state.ApplicationInformation.ActiveRound
  );

  const disabled = ActiveRound;
  //get user inormation
  const [userInfo, setUserinfo] = useState({
    ...state.UserInfo?.userToken?.userToken,
  });

  const dataJson = async () => {
    let jsonData = await loadConfig();
    SetDataJsonObject(jsonData);
  };

  //to get data json from main.js
  useEffect(() => {
    dataJson();
    dispatch(GetActiveRoundRemaining());
  }, []);

  const [lang, setLang] = useState(localStorage.getItem("lang") || "ar");

  const UpdateAcademicAchievementFunction = async () => {
    console.log(academicAchievement, "ssssjiidjiiiwjjjw");

    // const formData = {
    //   AcademicAchievementId: academicAchievement?.academicAchievementId,
    //   SpecializationCertificateAttachment:
    //     academicAchievement?.specializationCertificateAttachment,
    //   YearOfGraduation_TimePeriodId:
    //     academicAchievement?.yearOfGraduation_TimePeriodId
    //       ? academicAchievement.yearOfGraduation_TimePeriodId
    //       : null,
    //   ApplicationInformationId:
    //     localStorage.getItem("ApplicationInformationId") ||
    //     ApplicationInformationId,
    // };
    // var result = await dispatch(UpdateAcademicAchievement(formData));
    const formData = new FormData();
    formData.append(
      "AcademicAchievementId",
      academicAchievement?.academicAchievementId
    );
    formData.append(
      "SpecializationCertificateAttachment",
      academicAchievement?.specializationCertificateAttachment
    );
    if (
      academicAchievement?.yearOfGraduation_TimePeriodId != null &&
      academicAchievement?.yearOfGraduation_TimePeriodId != undefined
    ) {
      formData.append(
        "YearOfGraduation_TimePeriodId",
        academicAchievement?.yearOfGraduation_TimePeriodId
      );
    }

    formData.append(
      "ApplicationInformationId",
      localStorage.getItem("ApplicationInformationId")
    );
    formData.append("file", academicAchievement?.file);
    var result = await dispatch(UpdateAcademicAchievement(formData));
    // console.log(result, "ttttttt");

    return result?.payload?.code;
  };

  const UpdateCurrentJobInformationSpecializationFunction = async () => {
    var resultData = await dispatch(
      UpdateCurrentJobInformationSpecialization({
        currentJobInformationSpecializationId:
          currentJobInformationSpecialization?.currentJobInformationSpecializationId,
        countryId: currentJobInformationSpecialization?.countryId,
        city: currentJobInformationSpecialization?.city,
        university_Institution:
          currentJobInformationSpecialization?.university_Institution,
        college: currentJobInformationSpecialization?.college,
        department: currentJobInformationSpecialization?.department,
        jobTitle: currentJobInformationSpecialization?.jobTitle,
        academicRankId: currentJobInformationSpecialization?.academicRankId,
        generalSpecialization:
          currentJobInformationSpecialization?.generalSpecialization,
        subspecialization:
          currentJobInformationSpecialization?.subspecialization,
        applicationInformationId:
          currentJobInformationSpecialization?.applicationInformationId,
      })
    );
    if (resultData.payload.code == 200) {
      return true;
    } else {
      return false;
    }
  };
  const UpdateApplicantInformation = async () => {
    var resultData = await dispatch(
      UpdateAI_NT_ApI_ApplicantInformation({
        ...ApplicantInformation,
      })
    );
    if (resultData.payload.code == 200) {
      return true;
    } else {
      return false;
    }
  };

  const AttachmentsAndDeclarationScreen = async () => {
    var resultData = await dispatch(
      UpdateAC_NT_AS_AwardSource({
        ...AwardSource,
      })
    );

    var resultcommit1 = await dispatch(
      UpdateAC_NT_CM_Commitment({
        ...Commitment,
      })
    );

    console.log(
      resultData?.payload?.code,
      resultcommit1?.payload?.code,
      "aaaaaaaaaaaaaaaaaaaa"
    );

    if (
      resultData?.payload?.code == 200 &&
      resultcommit1?.payload?.code == 200
    ) {
      return true;
    } else {
      return false;
    }
  };

  const formData = new FormData();

  QuestionsAnswers.forEach((item, index) => {
    formData.append(
      `sC_NT_RC_QuestionsAnswersUpdateListModels[${index}].questionsAnswersId`,
      item.questionsAnswersId
    );
    formData.append(
      `sC_NT_RC_QuestionsAnswersUpdateListModels[${index}].answer`,
      item.answer ?? ""
    );
    formData.append(
      `sC_NT_RC_QuestionsAnswersUpdateListModels[${index}].questionTextAr`,
      item.questionTextAr ?? ""
    );
    formData.append(
      `sC_NT_RC_QuestionsAnswersUpdateListModels[${index}].questionTextEn`,
      item.questionTextEn ?? ""
    );
    formData.append(
      `sC_NT_RC_QuestionsAnswersUpdateListModels[${index}].sorting`,
      item.sorting ?? ""
    );
    formData.append(
      `sC_NT_RC_QuestionsAnswersUpdateListModels[${index}].questionsId`,
      item.questionsId ?? ""
    );
    formData.append(
      `sC_NT_RC_QuestionsAnswersUpdateListModels[${index}].number`,
      item.number ?? ""
    );
    formData.append(
      `sC_NT_RC_QuestionsAnswersUpdateListModels[${index}].attachments`,
      item.attachments ?? ""
    );
    formData.append(
      `sC_NT_RC_QuestionsAnswersUpdateListModels[${index}].applicationInformationId`,
      item.applicationInformationId ?? ""
    );
    formData.append(
      `sC_NT_RC_QuestionsAnswersUpdateListModels[${index}].numberShowStatus`,
      item.numberShowStatus ?? ""
    );
    formData.append(
      `sC_NT_RC_QuestionsAnswersUpdateListModels[${index}].attachmentsShowStatus`,
      item.attachmentsShowStatus ?? ""
    );

    if (item.file) {
      formData.append(
        `sC_NT_RC_QuestionsAnswersUpdateListModels[${index}].file`,
        item.file
      );
    }
  });

  const ScientificContributionSubmittedForTheAward = async () => {
    var resultData = await dispatch(UpdateQuestionsAnswersList(formData));

    var resultResearcher = await dispatch(
      UpdateSC_NT_RI_ResearcherIndicators({
        ...ResearcherIndicators,
      })
    );
    var resultApplication = await dispatch(
      UpdateSC_NT_AI_ApplicationInformation({
        ...SC_NT_AI_ApplicationInformation,
      })
    );
    if (
      resultData?.payload?.code == 200 &&
      resultResearcher?.payload?.code == 200 &&
      resultApplication?.payload?.code == 200
    ) {
      return true;
    } else {
      return false;
    }
  };
  console.log(location, "location?.state");

  const SaveData = async () => {
    if (!disabled) {
      if (location?.pathname?.includes("WorkInformationAndAcademic")) {
        var AcademicAchievement = await UpdateAcademicAchievementFunction();
        var CurrentJobInfo =
          await UpdateCurrentJobInformationSpecializationFunction();
        location = null;
      }
      if (location?.pathname?.includes("ApplicationInformation")) {
        var ApplicantInfo = await UpdateApplicantInformation();
      }
      if (location?.pathname?.includes("AttachmentsAndDeclarationScreen")) {
        var AttachmentsAndDec = await AttachmentsAndDeclarationScreen();
        location = null;
      }
      if (
        location?.pathname?.includes(
          "ScientificContributionSubmittedForTheAwardScreen"
        )
      ) {
        var ScientificContribution =
          await ScientificContributionSubmittedForTheAward();
        location = null;
      }
      if (
        AcademicAchievement ||
        ScientificContribution ||
        AttachmentsAndDec ||
        ApplicantInfo ||
        CurrentJobInfo
      ) {
        return true;
      } else {
        return true;
      }
    } else {
      return true;
    }
  };
  useEffect(() => {
    document.documentElement.lang = lang;
    document.documentElement.dir = lang === "ar" ? "rtl" : "ltr";

    localStorage.setItem("lang", lang);
    dispatch(setLanguage(lang));
  }, [lang]);
  console.log(state.UserInfo, "UsddddddddddderInfo");
  const [showAccessibility, setShowAccessibility] = useState(false);

  let access;
  const [accessInstance, setAccessInstance] = useState(null);

  useEffect(() => {
    let access;

    const initAccessibility = () => {
      access = new Accessibility({
        root: document.getElementById("accessibility-root"), // toolbar renders here
        textToSpeechLang: "en-US",
        speechToTextLang: "en-US",
        session: { persistent: true },
        labels:
          lang === "ar"
            ? {
                menuTitle: "خيارات الوصول",
                increaseText: "تكبير الخط",
                decreaseText: "تصغير الخط",
                invertColors: "عكس الألوان",
                increaseTextSpacing: "زيادة تباعد النص",
                decreaseTextSpacing: "تقليل تباعد النص",
                increaseLineHeight: "زيادة ارتفاع السطر",
                decreaseLineHeight: "تقليل ارتفاع السطر",
                grayHues: "تدرجات رمادية",
                underlineLinks: "تسطير الروابط",
                bigCursor: "مؤشر كبير",
                readingGuide: "دليل القراءة",
                textToSpeech: "قراءة النص",
                speechToText: "إملاء صوتي",
                disableAnimations: "إيقاف الحركات",
                reset: "إعادة الضبط",
              }
            : {
                menuTitle: "Accessibility Options",
              },
        modules: {
          decreaseText: true,
          increaseText: true,
          invertColors: true,
          increaseTextSpacing: true,
          decreaseTextSpacing: true,
          increaseLineHeight: true,
          decreaseLineHeight: true,
          grayHues: true,
          underlineLinks: false,
          bigCursor: true,
          readingGuide: false,
          textToSpeech: true,
          speechToText: true,
          disableAnimations: true,
          reset: true,
        },
        icon: {
          useDefault: false, // disable floating icon completely
        },
      });

      setAccessInstance(access);
    };

    if (document.readyState === "complete") {
      initAccessibility();
    } else {
      window.addEventListener("load", initAccessibility);
    }

    return () => {
      if (access && access.menuInterface?.destroy) {
        access.menuInterface.destroy();
      }
      window.removeEventListener("load", initAccessibility);
    };
  }, [lang]);
  // Click handler to open the accessibility menu
  const handleAccessClick = () => {
    if (accessInstance && accessInstance.menuInterface?.open) {
      accessInstance.menuInterface.open();
    }
  };

  useEffect(() => {
    if (lang === "en") {
      // Icon
      document.documentElement.style.setProperty("--_access-icon-left", "10px");
      document.documentElement.style.setProperty(
        "--_access-icon-right",
        "unset"
      );

      // Menu
      document.documentElement.style.setProperty("--_access-menu-left", "10px");
      document.documentElement.style.setProperty(
        "--_access-menu-right",
        "auto"
      );
    } else {
      // Icon
      document.documentElement.style.setProperty(
        "--_access-icon-right",
        "10px"
      );
      document.documentElement.style.setProperty(
        "--_access-icon-left",
        "unset"
      );

      // Menu
      document.documentElement.style.setProperty(
        "--_access-menu-right",
        "10px"
      );
      document.documentElement.style.setProperty("--_access-menu-left", "auto");
    }
  }, [lang]);
  // console.log(accessInstance, "accessInstance");

  const [countdown, setCountdown] = useState("");

  useEffect(() => {
    if (!ActiveRoundRemaining?.endDate) return;

    // timer function
    const timer = setInterval(() => {
      const end = new Date(ActiveRoundRemaining.endDate);
      const now = new Date();

      const diff = end - now;

      if (diff <= 0) {
        setCountdown(lang === "ar" ? "انتهى الوقت" : "Time is over");
        clearInterval(timer);
        return;
      }

      const days = Math.floor(diff / (1000 * 60 * 60 * 24));
      const hours = Math.floor((diff / (1000 * 60 * 60)) % 24);
      const minutes = Math.floor((diff / (1000 * 60)) % 60);
      const seconds = Math.floor((diff / 1000) % 60);

      setCountdown(
        `${days} ${lang === "ar" ? "يوم و" : "days"} ${hours
          .toString()
          .padStart(2, "0")}:${minutes.toString().padStart(2, "0")}:${seconds
          .toString()
          .padStart(2, "0")}`
      );
    }, 1000);

    return () => clearInterval(timer);
  }, [ActiveRoundRemaining, lang]);

useEffect(() => {
  const observer = new MutationObserver(() => {
    const menu = document.querySelector("._access-menu");
    const closeBtn = document.querySelector("._menu-close-btn");

    if (menu && closeBtn && !closeBtn._bound) {
      closeBtn._bound = true;
      closeBtn.addEventListener("click", () => {
        menu.style.display = "none";
      });
    }
  });

  observer.observe(document.body, { childList: true, subtree: true });

  return () => observer.disconnect();
}, []);

  
  return (
    <div
      className="headerPage"
      style={{
        direction: lang === "ar" ? "rtl" : "ltr",
      }}
    >
      {/* Logo Section */}
      <div className="LogoImageContainer">
        <img className="logoImage" src={img} alt="Logo" />
      </div>
      {/* Remaining Time Section */}
      {ActiveRoundRemaining &&
        !window.location.href.includes("manager") &&
        Object.keys(ActiveRoundRemaining ?? {}).length > 0 && (
          <div
            className="RemainingTimeContainer"
            style={{
              marginLeft: lang === "ar" ? "-165px" : "0",
              marginRight: lang === "en" ? "-165px" : "0",
            }}
          >
            <div className="pulse-bg"></div>

            <div className="icon-wrapper">
              <i className="bi bi-alarm alarm-icon"></i>
            </div>

            <span className="text-inline">
              {lang === "ar" ? "متبقي على الإغلاق :" : "Submission ends in :"}
            </span>

            <span className="text-count">{countdown}</span>
          </div>
        )}

      {/* Icons Section */}
      <div className="IconsContainer">
        {/* Home */}
        {localStorage.getItem("ApplicationInformationId") && (
          <div
            className="HomeIcon"
            // title={lang === "en" ? "Home" : "الرئيسية"}
            data-header-tooltip={lang === "en" ? "Home" : "الرئيسية"}
            onClick={async () => {
              if (window.location.href.includes("manager")) {
                window.location.replace("/ResearchersAward/manager/RequestsManager");
              } else {
                var success = await SaveData();
                if (success) {
                  window.location.replace("/ResearchersAward/mainpage");
                }
              }
            }}
          >
            <i className="bi bi-house"></i>
          </div>
        )}

        {/* User Info */}
        <div
          className="UserIcon"
          // title={UserInfo?.firstName + " " + UserInfo?.lastName}
          data-header-tooltip={UserInfo?.firstName + " " + UserInfo?.lastName}
        >
          <i className="bi bi-people"></i>
        </div>

        {/* Contact Info */}
        {/* <div className="ContactIcons"> */}
        <a
          // title={dataJsonObject?.AwardNumber}
          data-header-tooltip={dataJsonObject?.AwardNumber}
          target="_blank"
          href={`tel:${dataJsonObject?.AwardNumber}`}
        >
          <i className="bi bi-telephone"></i>
        </a>
        <a
          // title={lang === "en" ? "Send Email" : "أرسل بريد إلكتروني"}
          // title={dataJsonObject?.AwardEmail}
          data-header-tooltip={dataJsonObject?.AwardEmail}
          href={`mailto:${dataJsonObject?.AwardEmail}`}
        >
          <i className="bi bi-envelope"></i>
        </a>
        {/* Language Switch */}
        <div
          className="LangSwitcher"
          // title={lang === "en" ? "ع" : "en"}
          data-header-tooltip={lang === "en" ? "ع" : "en"}
          // onClick={async () => {
          //   var success = await SaveData();
          //   if (success) {
          //     setLang(lang === "ar" ? "en" : "ar");
          //     window.location.reload();
          //   }
          // }}
          onClick={async () => {
            var success = await SaveData();
            if (success) {
              const newLang = lang === "ar" ? "en" : "ar";
              setLang(newLang);
              localStorage.setItem("lang", newLang);
              setTimeout(() => window.location.reload(), 50);
            }
          }}
        >
          <FontAwesomeIcon icon={faGlobe} />
        </div>
        <div
          className="MyAccessIcon"
          data-header-tooltip={
            lang === "ar" ? "إعدادات الوصول" : "Accessibility"
          }
          onClick={() => {
            const accessButton = document.querySelector("._access-icon");
            const accessMenu = document.querySelector("._access-menu");

            if (!accessButton || !accessMenu) {
              console.warn("Accessibility elements not found");
              return;
            }
            console.log(accessMenu.classList, "classList");
            console.log(accessMenu, "accessMenu");

            // trigger original accessibility behavior
            accessButton.click();

            // toggle visibility
            if (
              accessMenu.style.display === "block" &&
              accessMenu.classList.contains("close")
            ) {
              accessMenu.style.display = "none";
            } else {
              accessMenu.style.display = "block";
            }
          }}
        >
          <i className="bi bi-universal-access"></i>
        </div>

        {/* Logout */}
        <div
          className="LogoutIcon"
          // title={lang === "en" ? "Log Out" : "خروج"}
          data-header-tooltip={lang === "en" ? "Log Out" : "خروج"}
          onClick={async () => {
            var success = await SaveData();
            if (success) {
              LogOutServices();
            }
          }}
        >
          <i className="bi bi-box-arrow-in-right"></i>
        </div>
        {/* </div> */}
        {showAccessibility && (() => setShowAccessibility(!showAccessibility))}
      </div>
    </div>
  );
};

export default Header;
